<template>
<div
  :style="eventStyle"
  :class='eventClass'
  @click.meta.stop='$emit("dayview:multiselect", event)'
  @click.exact='$emit("click", event)'
  class='event' :id="'event-'+event.id" >
  <!-- <div class='triangle' /> -->
  <v-progress-linear
    v-show='event.loading'
    :indeterminate="true"></v-progress-linear>
  <div>
    <v-tooltip
      v-model='tooltips.invoiceable'
      @click.native.stop='tooltips.invoiceable = !tooltips.invoiceable' right>
    <v-icon
      slot='activator'
      color='amber'
      style='font-size:12px;'
      small v-if='event.invoiceable' >check</v-icon>
      <span>Ready for invoicing</span>
    </v-tooltip>

    <v-tooltip v-if='event.is_online' bottom>
      <template v-slot:activator="{ on }">
        <v-icon v-on='on' dark small >headset_mic</v-icon>
      </template>
      <span>This meeting is online</span>
    </v-tooltip>
    <!-- - {{event.end}} -->
    <v-tooltip v-if='event.is_recurring' bottom>
      <template v-slot:activator="{ on }">
        <v-icon v-on="on"
          style='font-size:12px;' small dark>replay</v-icon>
      </template>
      <span>Recurring appointment</span>
    </v-tooltip>
    <!-- {{event.styles}} | {{event.start}} | {{event.dayStartHour}} | {{startHour}} -->
    <small class='time' >{{event.start}} - {{event.end}}</small>.
    <span v-if='event.title' >{{event.title}}</span>
    <span v-else >{{event.full_name}}</span>

    <v-tooltip v-if='infoIsTeamAccount && event.space_color && event.duration > 20' bottom>
      <template v-slot:activator="{ on }">
        <v-avatar :color='event.space_color' class='white--text' size=12  style='font-size:8px;' v-on='on'>
          <template v-if='event.space_name' >{{ event.space_name[0] }}</template>
          <template v-else-if='event.service_name' >{{ event.service_name[0] }}</template>
        </v-avatar>
      </template>
      <span>{{event.space_name || event.service_name}}</span>
    </v-tooltip>

    <v-tooltip v-if='event.product_color && event.duration > 20' bottom>
      <template v-slot:activator="{ on }">
        <v-avatar :color='event.product_color' class='white--text' size=12 style='font-size:8px;' v-on='on'>
          <template v-if='event.product_name' >{{ event.product_name[0] }}</template>
        </v-avatar>
      </template>
      <span>{{event.product_name}}</span>
    </v-tooltip>
    <!-- <br/> {{pixelToMinuteRatio}}|{{maxWidthPercentage}} -->
    <!-- <br/>{{event.partialOverlapCount}} | {{event.exactOverlapCount}} -->
    <!-- <span v-if='event.service_name' >{{event.service_name}}</span> -->
  </div>

</div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'DayEvent',
  props: {
    value: { type: Object, required: true },
    selectedEvent: { type: Object },
    eventOffset: { type: Number, default: 5 },
    startHour: { type: Number, default: 5 },
    periodInMins: { type: Number, default: 15 },
    defaultNewEventLength: { type: Number, default: 30 },
    pixelToMinuteRatio: { type: Number, default: 1 },
    maxWidthPercentage: { type: Number, default: 90 }
  },
  data () {
    return {
      tooltips: {
        invoiceable: false
      }
    }
  },
  methods: {
    timeToPixels (fromTimeString, toTimeString) {
      let startMoment = this.timeStringToMoment(fromTimeString)
      let toMoment = this.timeStringToMoment(toTimeString)
      let duration = moment.duration(toMoment.diff(startMoment))
      let height = duration.asMinutes()
      if (this.pixelToMinuteRatio > 1) {
        height = height * this.pixelToMinuteRatio
      }
      return height
    }
  },
  computed: {
    event () {
      return this.value
    },
    periodHeight () {
      return (this.periodInMins * this.pixelToMinuteRatio)
    },
    eventClass () {
      let event = this.event
      let selectedEvent = this.selectedEvent
      let data = {}
      if (selectedEvent) {
        data['elevation-5'] = event.id === selectedEvent.id
      }
      if (event.selected) {
        data['elevation-5'] = true
      }
      if (this.globalSelectedAppointmentIds && this.globalSelectedAppointmentIds.length > 0) {
        if (this.globalSelectedAppointmentIds.indexOf(event.id) > -1) {
          data['elevation-5'] = true
        }
      }
      if (event.highlight) {
        data['elevation-5'] = true
      }
      if (event.status) {
        let statusClass = `status-${event.status.toLowerCase()}`
        data[statusClass] = true
      }

      return data
    },
    eventStyle () {
      let event = this.event
      let top = this.timeToPixels(`0${this.startHour}` + ':00', event.start)
      if (this.pixelToMinuteRatio > 1) {
        top = top - (this.periodHeight / this.pixelToMinuteRatio)
      }
      let styles = {
        top: top + 'px',
        height: this.timeToPixels(event.start, event.end) + 'px'
      }
      if (event.partialOverlapCount > 0) {
        let offset = (event.partialOverlapCount * this.eventOffset)
        let width = this.maxWidthPercentage - offset
        styles['left'] = offset + '%'
        styles['width'] = width + '%'
      }
      if (event.exactOverlapCount > 1) {
        let unitPercent = this.maxWidthPercentage / event.exactOverlapCount
        styles['left'] = (event.exactOverlapSequence * unitPercent) + '%'
        styles['width'] = unitPercent + '%'
      }
      let target = document.getElementById('event-' + event.id)
      if (target) {
        // target.style.webkitTransform =
        target.style.transform = 'translate(0px, 0px)'
        // clear the position attributes
        target.setAttribute('data-x', 0)
        target.setAttribute('data-y', 0)
      }

      return styles
    }
  }
}
</script>



// WEBPACK FOOTER //
// DayEvent.vue?01319ac1